import { produce } from 'immer';
import { orderBy } from 'lodash';

import { AddInternalMarketerProduct } from '../../../actions/marketer/internal/addInternalMarketerProduct';
import { routeMarketerProductsToKeyMap } from '../../../service/MarketersHelper';
import { MarketerProduct, MarketerState } from '../../../typings/marketers';

export function addInternalMarketerProduct(state: MarketerState, action: AddInternalMarketerProduct): MarketerState {
    return produce(state, draft => {
        draft.marketer.ownProducts.push(action.product);

        if (action.productsSortParams) {
            draft.marketer.ownProducts = orderBy<MarketerProduct>(
                draft.marketer.ownProducts,
                [routeMarketerProductsToKeyMap[action.productsSortParams.key]],
                [action.productsSortParams.direction]
            );
        }
    });
}
